import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchAdminBuildings_buildingIdHeatingSettings = z.any()
export type TagsPatchAdminBuildings_buildingIdHeatingSettings = z.infer<typeof tagsPatchAdminBuildings_buildingIdHeatingSettings>

export const paramsPatchAdminBuildings_buildingIdHeatingSettings = z.object({ "buildingId": z.string().uuid() })
export type ParamsPatchAdminBuildings_buildingIdHeatingSettings = z.infer<typeof paramsPatchAdminBuildings_buildingIdHeatingSettings>

export const bodyPatchAdminBuildings_buildingIdHeatingSettings = z.object({ "stationId": z.union([z.string().min(1).max(64), z.null()]).optional(), "temperaturePeriod": z.object({ "from": z.string().date(), "to": z.union([z.string().date(), z.null()]), "temperatureC": z.number().gte(0).lte(40) }).optional(), "clearTemperaturePeriod": z.object({ "from": z.string().date(), "to": z.union([z.string().date(), z.null()]) }).optional(), "heatingSharePercent": z.number().gte(0).lte(100).optional(), "heatingRule": z.object({ "limitC": z.union([z.number().gte(-30).lte(40), z.null()]), "seasonOnly": z.boolean() }).optional() }).strict()
export type BodyPatchAdminBuildings_buildingIdHeatingSettings = z.infer<typeof bodyPatchAdminBuildings_buildingIdHeatingSettings>

export const responsePatchAdminBuildings_buildingIdHeatingSettings = z.object({ "payload": z.object({ "saved": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchAdminBuildings_buildingIdHeatingSettings = z.infer<typeof responsePatchAdminBuildings_buildingIdHeatingSettings>

interface IPatchAdminBuildings_buildingIdHeatingSettings extends BaseMethodType {
  tags: TagsPatchAdminBuildings_buildingIdHeatingSettings,
  params: ParamsPatchAdminBuildings_buildingIdHeatingSettings,
  body: BodyPatchAdminBuildings_buildingIdHeatingSettings,
  response: ResponsePatchAdminBuildings_buildingIdHeatingSettings
}
export const URL = '/admin/buildings/:buildingId/heating/settings'
export const validation = {
  patch: {
    tags: tagsPatchAdminBuildings_buildingIdHeatingSettings,
    params: paramsPatchAdminBuildings_buildingIdHeatingSettings,
    body: bodyPatchAdminBuildings_buildingIdHeatingSettings,
    response: responsePatchAdminBuildings_buildingIdHeatingSettings
  }
}
export interface AdminBuildings_buildingIdHeatingSettings extends BaseRouteType {
  patch: IPatchAdminBuildings_buildingIdHeatingSettings
}